import {
  KeySquareIcon as AccessibilityIcon,
  BackpackIcon,
  MailIcon as EnvelopeClosedIcon,
  MailOpenIcon as EnvelopeOpenIcon,
  EyeOffIcon as EyeNoneIcon,
  SmileIcon as FaceIcon,
  FileTextIcon,
  HomeIcon,
  LockIcon as LockClosedIcon,
  NotebookIcon as ReaderIcon,
} from 'lucide-react';

type IconProps = React.HTMLAttributes<SVGElement>;

export const Icons = {
  EnvelopeOpen: EnvelopeOpenIcon,
  EnvelopeClose: EnvelopeClosedIcon,
  Text: FileTextIcon,
  Face: FaceIcon,
  Accessibility: AccessibilityIcon,
  Home: HomeIcon,
  EyeNone: EyeNoneIcon,
  LockClosed: LockClosedIcon,
  Backpack: BackpackIcon,
  Reader: ReaderIcon,
  Spinner: (props: IconProps) => (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' {...props}>
      <path d='M21 12a9 9 0 1 1-6.219-8.56' />
    </svg>
  ),
};
